import { render, staticRenderFns } from "./MenuAddEditSidebar.vue?vue&type=template&id=483cb0ce&scoped=true&"
import script from "./MenuAddEditSidebar.vue?vue&type=script&lang=js&"
export * from "./MenuAddEditSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MenuAddEditSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MenuAddEditSidebar.vue?vue&type=style&index=1&id=483cb0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483cb0ce",
  null
  
)

export default component.exports